import React from 'react';
import YouTube, { YouTubeProps } from 'react-youtube';
import MediaBox, { MediaBoxAspect, MediaBoxType } from 'components/media-box/media-box';
import lexemes from 'components/lexemes';

const VIDEO_ID = 'FQvWVCmPsTE';
const opts = {
    height: '100%',
    width: '100%',
    playerVars: {
        autoplay: 1,
        color: 'white',
        modestbranding: 1,
        rel: 0,
    },
};
const campaignName = 'Badoo Safety Center video from ';
// is taken from video width/height
const VIDEO_ASPECT_RATIO = (720 / 1280) * 100;

const PageVideoBlock: React.FC<{ video?: string }> = ({ video }) => {
    // const PageVideoBlock = ({ titleElement }: { titleElement?: React.ReactNode }) => {
    const [isOpened, setOpened] = React.useState(false);
    const playBackHandler: YouTubeProps['onPlay'] = () => {
        setOpened(!isOpened);
    };

    React.useEffect(() => {
        /**
         * solving bag with fullscreen opens and closes window
         */
        const ua = global.navigator.userAgent;

        if (
            !!ua.match(/(iPad).*OS\s([\d_]+)/) ||
            !!ua.match(/(iPhone\sOS)\s([\d_]+)/) ||
            !!ua.match(/(Android)\s+([\d.]+)/) ||
            !!ua.match(/Silk-Accelerated/)
        ) {
            setOpened(true);
        }
    }, [setOpened]);

    return isOpened ? (
        <div
            style={{
                width: '100%',
                position: 'relative',
            }}
        >
            <div
                style={{
                    width: '100%',
                    paddingTop: `${VIDEO_ASPECT_RATIO}%`,
                }}
            ></div>
            <div className="media-box-youtube">
                <YouTube
                    videoId={video || VIDEO_ID}
                    className="media-box-youtube__frame"
                    opts={opts as YouTubeProps['opts']}
                    onEnd={playBackHandler}
                    onReady={() => {
                        if (global.window.ga) {
                            global.window.ga('set', 'location', global.window.location.href);
                            global.window.ga(
                                'send',
                                'event',
                                campaignName + global.window.location.href,
                                'load',
                                campaignName + global.window.location.href,
                                {
                                    nonInteraction: true,
                                }
                            );
                        }
                    }}
                    onStateChange={(event) => {
                        const playerState = Object.entries(YouTube.PlayerState).find(
                            (item) => item[1] === event.target.getPlayerState()
                        );
                        if (global.window.ga) {
                            global.window.ga(
                                'send',
                                'event',
                                campaignName + global.window.location.href,
                                playerState && playerState[0] ? playerState[0] : 'undefined',
                                campaignName + global.window.location.href
                            );
                        }
                    }}
                />
            </div>
        </div>
    ) : (
        <MediaBox
            type={MediaBoxType.VIDEO}
            aspect={MediaBoxAspect.INTRO_BANNER}
            src={'/safety-centre/assets/video-bg-2.jpg'}
            hasVideoOpenAnimation={true}
            onExternalPlayClick={playBackHandler}
            priority={true}
            a11y={{
                label: lexemes.videoBlock.lxVideoStubA11yLabel(),
            }}
        />
    );
};

export default PageVideoBlock;
